<template>
  <v-flex
    xs3
    class="section-steps__sidebar hidden-sm-and-down"
    :class="$vuetify.breakpoint.mdOnly ? 'mr-3' : ''"
  >
    <slot />
    <template v-if="!currentQuestionnaire.is_open_item">
      <v-layout class="title" align-center>
        <span
          class="display-4 mx-2 primary--text font-weight-bold section-step__number"
          >{{ activeSection }}</span
        >
        <span class="title mx-1 font-weight-bold grey--text text--darken-1"
          >/</span
        >
        <span
          class="title font-weight-bold grey--text text--darken-1 section-step__max-number"
          >{{ sections.length }}</span
        >
      </v-layout>

      <v-layout
        class="my-3"
        :class="rightToLeft ? 'text-xs-right' : 'text-xs-left'"
        column
        v-for="section in shownSections"
        :key="section.id"
        style="cursor: pointer"
      >
        <v-layout align-center @click="goToSection(section)">
          <v-icon color="grey" size="15" v-if="section.locked"> lock </v-icon>

          <v-icon
            color="success"
            size="15"
            v-else-if="
              sectionCompleted(currentQuestionnaire, section) &&
                !sectionHasAllOptionalUnansweredQuestions(
                  currentQuestionnaire,
                  section,
                )
            "
          >
            check
          </v-icon>

          <v-icon color="error" size="15" v-else-if="showUnanswered">
            error_outline
          </v-icon>

          <div v-else class="mr-3"></div>

          <v-tooltip
            bottom
            v-if="sectionKey(section) === 'delivery'"
            class="subheading font-weight-bold ml-1"
            :class="
              currentSection === section
                ? 'subheading primary--text'
                : !reviewAndSubmitSectionFinished(currentQuestionnaire)
                ? 'grey--text'
                : 'darkgrey--text'
            "
          >
            <span slot="activator">{{ section.name }}</span>
            <span>Please submit the answers before this section</span>
          </v-tooltip>

          <span
            v-else
            class="subheading font-weight-bold ml-1"
            :class="
              currentSection === section
                ? 'subheading primary--text'
                : 'darkgrey--text'
            "
          >
            {{ buildSectionName(section) }}
          </span>
        </v-layout>
      </v-layout>
      <v-divider class="mt-5" v-if="showDocumentChecklistDialog" />
      <v-tooltip bottom v-if="showDocumentChecklistDialog">
        <v-layout
          slot="activator"
          class="text-xs-left mt-3"
          align-center
          style="cursor: pointer"
          @click="$emit('open-document-checklist-dialog')"
        >
          <v-icon
            size="15"
            :class="
              documentChecklistDialogOpened ? 'primary--text' : 'darkgrey--text'
            "
          >
            assignment
          </v-icon>
          <span
            class="ml-1 font-weight-bold"
            :class="
              documentChecklistDialogOpened ? 'primary--text' : 'text--darken-1'
            "
          >
            {{ $t('questionnaire.checklist') }}
          </span>
        </v-layout>
        <span>{{ $t('questionnaire.seeDocsAlert') }}</span>
      </v-tooltip>
    </template>
  </v-flex>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';
import QuestionnaireMixin from '../mixins/QuestionnaireMixin';
import FirmPreferenceMixins from '../mixins/FirmPreferenceMixins';
import UtilsMixins from '../mixins/UtilsMixins';

export default {
  props: {
    preview: {
      type: Boolean,
    },
    currentSection: {
      type: Object,
    },
    currentSubsection: {
      type: String,
    },
    subsections: {
      type: Array,
    },
    activeSection: {},
    currentQuestionnaire: {
      type: Object,
    },
    showUnanswered: {
      type: Boolean,
    },
    documentChecklistDialogOpened: {
      type: Boolean,
    },
    buildSectionName: {
      type: Function,
    },
    sectionHasAllOptionalUnansweredQuestions: {
      type: Function,
    },
  },
  mixins: [QuestionnaireMixin, FirmPreferenceMixins, UtilsMixins],
  methods: {
    isEmpty,
    goToSection(section) {
      if (this.currentSection.id === section.id) {
        return;
      } else if (section.locked) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'This section is locked.',
        });
      } else {
        this.$emit('go-to-section', section);
      }
    },
    goToSubsection(subsection) {
      this.$emit('go-to-subsection', subsection);
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
    showDocumentChecklistDialog() {
      return (
        !this.currentQuestionnaire.is_open_item &&
        !isEmpty(this.currentQuestionnaire.questionnaire_questions) &&
        !this.currentQuestionnaire.hide_checklist &&
        this.currentQuestionnaire.deposit_status !== 'pending' &&
        !this.currentQuestionnaire.show_uploads_as_document_checklist &&
        this.documentChecklistDialogEnabled
      );
    },
    sectionsAllCompleted() {
      return this.sections.every(section =>
        this.sectionCompleted(this.currentQuestionnaire, section),
      );
    },
  },
};
</script>

<style lang="postcss" scoped>
.section {
  &-steps {
    &__container {
      max-width: 1000px;
      margin: 0 auto;
    }
    &__sidebar {
      position: sticky;
      top: 100px;
    }
    &__text {
      font-weight: bold;
      margin-left: 6px;
    }
  }
}
</style>
